export interface LanguageItem {
  textId: string;
  id: string;
}

export const SUPPORTED_LANGUAGES: LanguageItem[] = [
  {
    textId: "Module.Option.Language.de",
    id: "de-DE"
  },
  {
    textId: "Module.Option.Language.en",
    id: "en-GB"
  },
  {
    textId: "Module.Option.Language.fr",
    id: "fr-BE"
  },
  {
    textId: "Module.Option.Language.nl",
    id: "nl-BE"
  },
  {
    textId: "Module.Option.Language.es",
    id: "es-ES"
  },
  {
    textId: "Module.Option.Language.cl",
    id: "es-CL"
  }
];
